module.exports = __webpack_public_path__ + "static/img/filter.118dfff5.svg";